var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "344px",
    height: "282px",
    viewBox: "0 0 344 282",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Button/boost-icon/normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-----------MISC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/boost-icon/normal",
    transform: "translate(-78.000000, -93.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    rx: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.625,174.107143 L380.625,374 C380.625,374.552285 380.177285,375 379.625,375 L299.125,375 C298.572715,375 298.125,374.552285 298.125,374 L298.125,174.107143 L267.845954,174.107143 C263.040382,174.107143 259.71345,172.125949 257.865157,168.163567 C256.016864,164.201186 256.75618,160.793533 260.083112,157.940617 L331.612158,96.6029163 C333.830113,94.7009721 336.41773,93.75 339.375,93.75 C342.33227,93.75 344.919887,94.7009721 347.137842,96.6029163 L418.666888,157.940617 C421.99382,160.793533 422.733136,164.201186 420.884843,168.163567 C419.03655,172.125949 415.709618,174.107143 410.904046,174.107143 L380.625,174.107143 Z M79.125,294.642857 L159.625,294.642857 C160.177285,294.642857 160.625,295.090572 160.625,295.642857 L160.625,374 C160.625,374.552285 160.177285,375 159.625,375 L79.125,375 C78.5727153,375 78.125,374.552285 78.125,374 L78.125,295.642857 C78.125,295.090572 78.5727153,294.642857 79.125,294.642857 Z M189.125,227.678571 L269.625,227.678571 C270.177285,227.678571 270.625,228.126287 270.625,228.678571 L270.625,374 C270.625,374.552285 270.177285,375 269.625,375 L189.125,375 C188.572715,375 188.125,374.552285 188.125,374 L188.125,228.678571 C188.125,228.126287 188.572715,227.678571 189.125,227.678571 Z",
    id: "Combined-Shape",
    fill: "#3A64B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostIcon);
export default __webpack_public_path__ + "static/media/boost-icon.33ed97367c4cb9d5ae3b1e842ddf2769.svg";
export { ForwardRef as ReactComponent };